const KEY = 'spacebase:localGame:v1';

export function saveLocalGame(gameState) {
  try {
    localStorage.setItem(KEY, JSON.stringify(gameState));
  } catch {
    // Storage full/unavailable (private browsing etc.) - losing autosave
    // isn't worth crashing the game over.
  }
}

export function loadLocalGame() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearLocalGame() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // ignore
  }
}
